var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Slider } from '../SlideDown';
export class Menu extends Component {
    constructor() {
        super('Menu', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('#button-toggle-menu').on('click', (event, button) => {
                event.preventDefault();
                button.toggleClass('active');
                $('#main-menu').toggleClass('opened');
                Slider.toggle($('#main-menu > .slide-down'));
            });
            $('.current-menu-ancestor').each((menu) => {
                Slider.toggle(menu.next(), true);
            });
            let hover_color = $('.current-menu-item').css('color');
            $('body').css({
                '--hover-color': hover_color,
                '--hover-stroke-color': hover_color,
                '--hover-fill-color': hover_color
            });
            $('body').on('click', (event) => {
                const targetParents = $(event.target).parents('#main-menu, header');
                if (targetParents.length == 0) {
                    $('#button-toggle-menu').removeClass('active');
                    $('#main-menu').removeClass('opened');
                    Slider.close($('#main-menu > .slide-down'));
                }
            });
            this.success();
        });
    }
}
